export default function(ngModule) {
    ngModule.factory('CouponCode', function(BaseClass,$q, $http) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function CouponCode(attributes) {
            _.assign(this,attributes);
        }
        CouponCode.modelName = 'CouponCode';


        BaseClass.apply(CouponCode);

        // This is a weird model. The validation applies to code generation, which will
        // happen in bulk. After that, you'll fetch the codes using `coupon.$queryCodes`
        CouponCode.validates({
            guid: {
                required: true
            },
            amount: {
                required: true,
                integer: true
            },
            length: {
                required: true,
                integer: true
            },
            applies_to_count: {
                integer: true
            },
            usage_count: {
                integer: true
            },
            format: {
                inclusion: {
                    in: ['upper','lower','number']
                }
            },
            ambiguous: {
                format: {
                    boolean: true
                }
            }
        });
        CouponCode.primaryKey = 'code';

        CouponCode.configureApi('/coupon/:guid/codes/:code');
        CouponCode.prototype.toString = function() { return this.name; };
        CouponCode.prototype.customCreate = function() {
            let codes = this.codes.split(/[,;\n]\s*/gm);
            return $http.put(`/coupon/${this.guid}/codes`, {
                codes: _.map(codes, code => _.set({}, 'code', code)),
                applies_to_count: this.applies_to_count,
                usage_count: this.usage_count
            }).then(() => {
                return _.map(codes, code => {
                    return CouponCode.new({
                        code: code,
                        applies_to_count: this.applies_to_count,
                        usage_count: this.usage_count,
                        used_count: 0
                    });
                });
            }).catch(error => {
                this.broadcastAPIMessage(error);
                return $q.reject(error);
            });
        };

        return CouponCode;
    });
}
